import clsx from "clsx"

import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea, TruncatableText } from "@particles/index"

import { IconButton } from "@atoms"

import styles from "./NavTopBarPageInnerTitle.module.scss"
import { NavTopBarPageInnerTitleProps } from "./NavTopBarPageInnerTitle.types"

export default function NavTopBarPageInnerTitle(props: NavTopBarPageInnerTitleProps) {
    const { backDestination, label } = props

    const { push } = useRouter()

    const onClick = () => {
        if (backDestination) {
            push(backDestination)
        }
    }

    return (
        <div className={styles.base}>
            {backDestination && (
                <ExtraTouchArea extraTouchArea={9}>
                    <IconButton
                        size="xs"
                        variant="ghost"
                        className="back-button"
                        icon={faIcon({ name: "arrow-left", style: "regular" })}
                        onClick={onClick}
                        aria-label="Navigate back"
                        noDebounce={true}
                    />
                </ExtraTouchArea>
            )}
            <TruncatableText text={label} className={clsx(styles.label, "page-subtitle")} />
        </div>
    )
}
